import api from './api';
import { claimQuickExpense, deleteQuickExpense, finishQuickExpenseAttempt, readQuickExpense } from './quickExpenseStorage';

const running = new Map();
const sameUser = (userId) => { try { return String(JSON.parse(localStorage.getItem('user'))?.id) === String(userId); } catch (_) { return false; } };
export const syncQuickExpenses = (userId) => {
  const id = String(userId);
  if (running.has(id)) return running.get(id);
  const work = (async () => {
    if (navigator.onLine === false || !sameUser(id)) return { sent: 0 };
    let sent = 0;
    while (sameUser(id) && navigator.onLine !== false) {
      const token = localStorage.getItem('token');
      if (!token) break;
      const draftId = await claimQuickExpense(id);
      if (!draftId) break;
      try {
        const draft = await readQuickExpense(id, draftId);
        const form = new FormData();
        Object.entries(draft.fields).forEach(([key, value]) => form.append(key, value ?? ''));
        form.append('client_request_id', draft.id);
        draft.files.forEach((file) => form.append('evidence_files', file));
        if (!sameUser(id)) { await finishQuickExpenseAttempt(id, draftId, { error: 'Inicia sesión con el usuario que creó el borrador.', retry: true }); break; }
        const { data } = await api.post('/expense-requests', form, { timeout: 60000, headers: { Authorization: `Bearer ${token}` } });
        if (!data.success || !data.request?.id) throw new Error('No se pudo confirmar el registro. La captura se conserva para reintentar.');
        await deleteQuickExpense(id, draftId, { sent: true });
        sent += 1;
        window.dispatchEvent(new CustomEvent('quick-expenses:sent', { detail: { userId: id, requestId: data.request.id } }));
      } catch (error) {
        const status = error.response?.status;
        const retry = !status || status >= 500 || status === 408 || status === 429;
        await finishQuickExpenseAttempt(id, draftId, { error: error.response?.data?.message || error.message || 'Sin conexión. Se reintentará al volver a abrir la app.', retry });
        break;
      }
    }
    return { sent };
  })().finally(() => running.delete(id));
  running.set(id, work);
  return work;
};

export const localExpenseDate = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};
export const quickExpenseError = (fields, files) => {
  if (!files.length) return 'Fotografía o adjunta al menos un comprobante.';
  if (files.length > 8 || files.some((file) => file.size > 12 * 1024 * 1024)) return 'Puedes adjuntar hasta 8 archivos de máximo 12 MB cada uno.';
  if (!String(fields.title || '').trim()) return 'Escribe el concepto del gasto.';
  if (!/^\d+(\.\d{1,2})?$/.test(String(fields.amount)) || Number(fields.amount) <= 0 || Number(fields.amount) > 9999999999.99) return 'Ingresa un importe válido mayor que cero, con máximo dos decimales.';
  if (String(fields.title || '').trim().length > 180 || String(fields.vendor_name || '').trim().length > 180) return 'El concepto y el proveedor deben tener máximo 180 caracteres.';
  if (!fields.category || !fields.expense_date) return 'Revisa la categoría y la fecha.';
  const dateKey = String(fields.expense_date);
  const parsed = new Date(`${dateKey}T12:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey) || Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== dateKey) return 'Revisa la fecha del gasto.';
  if (!['MXN', 'USD'].includes(fields.currency)) return 'Selecciona MXN o USD.';
  if (String(fields.invoice_number || '').trim().length > 120 || String(fields.description || '').length > 10000) return 'Revisa la longitud del folio o las notas.';
  return '';
};
